import { useState } from 'react';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
  {
    id: 1,
    src: "/images/pic_1.jpeg",
    alt: "Garden",
    span: "col-span-2 row-span-2",
  },
  {
    id: 2,
    src: "/images/pic_2.jpeg",
    alt: "Restaurant Dining",
    span: "col-span-1 row-span-1",
  },
  {
    id: 3,
    src: "/images/pic_3.jpeg",
    alt: "Resort Exterior",
    span: "col-span-1 row-span-1",
  },
  {
    id: 4,
    src: "/images/pic_4.jpeg",
    alt: "Garden View",
    span: "col-span-1 row-span-1",
  },
  {
    id: 5,
    src: "/images/pic_5.jpeg",
    alt: "Nature View",
    span: "col-span-1 row-span-2",
  },
  {
    id: 6,
    src: "/images/pic_6.jpeg",
    alt: "Room Interior",
    span: "col-span-2 row-span-1",
  },
];

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 bg-jungle-50"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="font-sans text-sm tracking-[0.3em] uppercase text-jungle-500 mb-4">
            Visual Journey
          </p>
          <h2
            data-testid="gallery-title"
            className="font-serif text-3xl md:text-5xl text-jungle-800 mb-6"
          >
            Gallery
          </h2>
          <div className="w-20 h-0.5 bg-earth-400 mx-auto" />
        </div>

        {/* Bento Grid Gallery */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px] md:auto-rows-[200px]">
          {images.map((image, index) => (
            <div
              key={image.id}
              data-testid={`gallery-image-${image.id}`}
              className={`${image.span} relative overflow-hidden rounded-xl cursor-pointer group`}
              onClick={() => setSelectedImage(image)}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-jungle-900/0 group-hover:bg-jungle-900/30 transition-colors duration-300" />
              <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white font-sans text-sm tracking-wide">
                  {image.alt}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          data-testid="lightbox-modal"
          className="fixed inset-0 z-50 bg-jungle-900/95 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            data-testid="lightbox-close"
            className="absolute top-6 right-6 text-white hover:text-earth-400 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-w-full max-h-[85vh] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <p className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white font-sans tracking-wide">
            {selectedImage.alt}
          </p>
        </div>
      )}
    </section>
  );
};

export default Gallery;
